export enum EProductsAcquisitionSteps {
  PRODUCTS,
  REVIEW,
  CONCLUSION
}
